import { render } from "./AppFurina.vue?vue&type=template&id=25b7e26e"
import script from "./AppFurina.vue?vue&type=script&lang=js"
export * from "./AppFurina.vue?vue&type=script&lang=js"

import "./AppFurina.vue?vue&type=style&index=0&id=25b7e26e&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__